import { msg } from '@lingui/macro';

export const ItemRoutes = {
  path: 'item',
  async lazy() {
    const { Parent } = await import('../pages/item');
    return { Component: Parent };
  },
  handle: { name: 'Items list', category: 'Items', title: msg`Items` },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('../pages/item');
        return { Component: Index };
      },
    },
    {
      path: '*',
      async lazy() {
        const { Parent } = await import('../pages/item');
        return { Component: Parent };
      },
      handle: { name: 'Item Details', category: 'Item' },
    },
  ],
};
